import Vue from 'vue'
import Router from 'vue-router'
import tenancyRouter from './tenancy'
import centralRouter from './central'
import axios from 'axios';
import CentralAuth from '../services/auth.service'
import TenantAuth from '../services/auth.tenant.service'
import Api from '../services/endpoint/central.service'
import Cookies from 'js-cookie'
import i18n from '@/plugins/i18n';

Vue.use(Router)

// Vue.config.productionTip = false;

const host = window.location.host;
const parts = host.split('.');
const url = new URL(window.location.href);
const param = url.searchParams.get("from");

let newCentrlRouter = centralRouter;

const outSiteGo = {
    gosell: 'GoSell ระบบหลังบ้านเต็มรูปแบบ'
}

if (url.pathname == '/login' || url.pathname == '/register') {
    if (param && param in outSiteGo) {
        newCentrlRouter = centralRouter.map(item => {
            if (item.name === 'auth.login' || item.name === 'auth.register') item.meta.suffix = outSiteGo[param]
            return item
        })
    }
}

const googgleCallbackHost = "http://127.0.0.1:8080";
if (host.includes("127.0.0.1") && process.env.NODE_ENV === 'local') {
    //redirect to central url when callback form google
    const queryString = new URLSearchParams(window.location.search).toString();
    window.location.href = process.env.CENTRAL_APP_URL + "/v1/auth/google/callback?" + queryString
}

let activeRouter = tenancyRouter
let isTenancyRouter = true;
const googleCallback = (process.env.NODE_ENV === 'local' && window.location.origin === googgleCallbackHost) ? true : false; //access google callback on  local

if (parts.length === 2 || window.location.origin == process.env.CENTRAL_ACC_URL || window.location.origin == process.env.CENTRAL_APP_URL || window.location.origin == 'www' || googleCallback || url.pathname == "/iframe") {
    activeRouter = newCentrlRouter
    isTenancyRouter = false
}

if (url.pathname == "/chk-status" || url.pathname == "/chk-order" || url.pathname == "/checkout/success" || url.pathname == "/checkout/failed") {
    isTenancyRouter = false
}

let router = new Router({
    mode: 'history',
    routes: activeRouter
})

router.beforeEach((to, from, next) => {

    if (to.path == '/login-sso') {
        CentralAuth.logout()
        if (Cookies.get('tenantToken')) {
            TenantAuth.logout()
        }
        Cookies.remove('centralToken');
        Cookies.remove('tenantToken');
        console.log('test-sso');
        console.log(to);
        next();
    }

    if (isTenancyRouter) {
        const checkPermission = Cookies.get('features')
        const checkActivate = Cookies.get('WmsSevice')

        if (checkPermission && !JSON.parse(checkPermission).includes('feature-gowms')) {
            if (to.name == 't.a.inventory-list'
                || to.name == 't.a.warehouse'
                || to.name == 't.a.inventory'
                || to.name == 't.a.stock-movement'
                || to.name == 't.a.purchases'
                || to.name == 't.a.suppliers'
                || to.name == 't.a.adjustments'
            ) {
                next({ name: 'Not Found' });
                setTimeout(() => {
                    window.history.replaceState({}, '', to.fullPath);
                }, 500);
            }
        } else {
            if (to.name == 't.a.inventory-list' || to.name == 't.a.warehouse') {
                if (checkActivate != 2) {
                    next({ name: 'Not Found' });
                    setTimeout(() => {
                        window.history.replaceState({}, '', to.fullPath);
                    }, 500);
                }
            }

            // WmsSevice
        }
        // const menu = Cookies.get('menus');
        // if (menu === undefined) {
        //     // CentralAuth.logout()
        //     if (Cookies.get('tenantToken')) {
        //         TenantAuth.logout()
        //     }
        //     window.location.href = process.env.CENTRAL_APP_URL + '/login'
        // }
    }

    switch (isTenancyRouter) {
        case false:
            const publicPages = [
                '/login-sso',
                '/sso-success',
                '/login',
                '/login/apple',
                '/register',
                '/forgotpassword',
                '/changepassword',
                '/successpassword',
                '/verify',
                '/v1/auth/line/callback',
                '/v1/auth/google/callback',
                '/v1/auth/facebook/callback',
                '/v1/auth/apple/callback',
                '/v1/auth/watiting',
                '/chk-status',
                '/chk-order',
                '/checkout/success',
                '/checkout/failed',
                '/iframe'
            ];
            const authRequired = !publicPages.includes(to.path);
            const centralLoggedIn = Cookies.get('centralToken');
            if (authRequired && !centralLoggedIn) {
                //redirect when mobile change password
                const queryString = new URLSearchParams(window.location.search).toString();

                next(false)
                if (queryString != '') {
                    window.location.href = process.env.CENTRAL_APP_URL + '/login?' + queryString
                } else {
                    window.location.href = process.env.CENTRAL_APP_URL + '/login'
                }

            } else if ((!authRequired && centralLoggedIn) || (centralLoggedIn && parts.length === 2)) {

                const goNext = ['/sso-success', '/store', '/v1/auth/line/callback', '/v1/auth/google/callback', '/v1/auth/facebook/callback', '/v1/auth/apple/callback', '/v1/auth/watiting', '/login/apple', '/chk-status', '/chk-order', '/checkout/success', '/checkout/failed', '/iframe']

                if (goNext.includes(to.path)) {
                    next();
                } else {
                    next(false)
                    if (to.path == '/general' && from.name == "SocialAccountCallback") {
                        window.location.href = process.env.CENTRAL_ACC_URL + '/general';
                        return
                    }

                    window.location.href = process.env.CENTRAL_ACC_URL + '/store'
                }
            } else next()
            break;
        default:
            const tenantLoggedIn = Cookies.get('tenantToken');
            if (!tenantLoggedIn) {
                next(false);
                window.location.href = process.env.CENTRAL_APP_URL + '/login'
            } else next();
            break;
    }
    if ($(".modal-backdrop").length > 0) {
        $(".modal-backdrop").remove();
        next();
    }
})

axios.interceptors.request.use((request) => {
    return request;
})
axios.interceptors.response.use((response) => {
    if (response.status === 201) {

        let queryString = "";

        if ("code" in response.data && response.data.code === "TENANT-FORCE-LOGOUT") {
            const domain = (new URL(response.config.url).host.split(".")[0]) + Math.random().toString(36).slice(2, 7)
            queryString = `?code=${window.btoa(JSON.stringify({ domain }))}`
            TenantAuth.logout()
        }

        // window.location.href = process.env.CENTRAL_ACC_URL + '/store' + queryString
    }
    return response
}, (error) => {
    if (error.response != undefined && error.response.status == 401) {
        const time = localStorage.getItem('isCypress') ? 2000 : 0
        if (Cookies.get('tenantToken') && error.response.data.code == 'FOUND_NEW_SUBSCRIPTION') {
            Vue.prototype.$swal({
                icon: "warning",
                iconColor: "#FF7043",
                title: i18n.t('Preparing new plan.'),
                // text: "You won’t be able to undo this action.",
                html: i18n.t(
                    "The system is working on updating the package. Please login to store again. Sorry for the inconvenience."
                ),
                confirmButtonText:
                    '<i class="fas fa-check-circle mr-1"></i>' + i18n.t("OK"),
                buttonsStyling: false,
                customClass: {
                    confirmButton: "btn btn-primary mr-2",
                },
                focusConfirm: false,
                preConfirm: async function () {
                    TenantAuth.logout();
                    window.location.href = process.env.CENTRAL_ACC_URL;
                }
            });
        } else if (Cookies.get('tenantToken')) {
            setTimeout(() => {
                TenantAuth.logout();
                window.location.href = process.env.CENTRAL_ACC_URL;
            }, time)

        } else {
            setTimeout(() => {
                CentralAuth.logout();
                window.location.href = process.env.CENTRAL_APP_URL;
            }, time)
        }
    }
    return Promise.reject(error);
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js